import { registerMicroApps, start, addGlobalUncaughtErrorHandler, initGlobalState } from 'qiankun'
import config from './config'
import { ElMessage } from 'element-plus'
import { $t as lang } from '@/Tool'
/**
 * 初始化全局state
 * @param {*} state
 */
export const initState = () => {
  // 初始化 state
  const defaultState = {
    currentStore: {},
  }
  const actions = initGlobalState(defaultState)
  actions.onGlobalStateChange((state, prev) => {
    // state: 变更后的状态; prev 变更前的状态
    console.log('app state', state)
    console.log('app prev', prev)
  })
  ;(window as any).mainAppGlobalStateActions = actions
  return actions
}
/**
 * 更新主应用state
 * @param {*} key
 * @param {*} state
 */
const setMainAppGlobalState = (key: any, state: any) => {
  //这里可以对上方的defaultState进行补充
  if ((window as any).mainAppGlobalStateActions) {
    ;(window as any).mainAppGlobalStateActions.setGlobalState({
      [key]: state,
    })
  }
}

function startQiankun() {
  // registerMicroApps(config)
  start()
  initState()

  addGlobalUncaughtErrorHandler((event) => {
    const { msg } = event as any
    // 加载失败时提示
    if (msg && msg.includes('died in status LOADING_SOURCE_CODE')) {
      ElMessage.error(lang('load.error'))
    }
  })
}
export { startQiankun, setMainAppGlobalState }
